import _defineProperty from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useContext } from "react";
import styled, { css } from "styled-components";
import defaultTheme from "../../defaultTheme";
import CircleSmall from "../../icons/CircleSmall";
import { rtlSpacing } from "../../utils/rtl";
import { StyledCarrierLogo } from "../../CarrierLogo";
import { SIZES, TYPES } from "../consts";
import { StyledText } from "../../Text";
import ListContext from "../ListContext";
export var getLineHeightToken = function getLineHeightToken(_ref2) {
  var _lineHeightTokens;

  var theme = _ref2.theme,
      size = _ref2.size;
  var lineHeightTokens = (_lineHeightTokens = {}, _defineProperty(_lineHeightTokens, SIZES.SMALL, theme.orbit.lineHeightTextSmall), _defineProperty(_lineHeightTokens, SIZES.NORMAL, theme.orbit.lineHeightTextNormal), _defineProperty(_lineHeightTokens, SIZES.LARGE, theme.orbit.lineHeightTextLarge), _lineHeightTokens);
  return lineHeightTokens[size];
};

var getSizeTokenLabel = function getSizeTokenLabel(_ref3) {
  var _sizeTokens;

  var theme = _ref3.theme,
      size = _ref3.size;
  var sizeTokens = (_sizeTokens = {}, _defineProperty(_sizeTokens, SIZES.SMALL, theme.orbit.fontSizeTextSmall), _defineProperty(_sizeTokens, SIZES.NORMAL, theme.orbit.fontSizeTextSmall), _defineProperty(_sizeTokens, SIZES.LARGE, theme.orbit.fontSizeTextNormal), _sizeTokens);
  return sizeTokens[size];
};

var getIconSizeFromType = function getIconSizeFromType(_ref4) {
  var _tokens;

  var theme = _ref4.theme,
      type = _ref4.type;
  var tokens = (_tokens = {}, _defineProperty(_tokens, TYPES.PRIMARY, css(["height:", ";width:", ";"], theme.orbit.heightIconSmall, theme.orbit.widthIconSmall)), _defineProperty(_tokens, TYPES.SECONDARY, css(["height:", ";width:", ";"], theme.orbit.heightIconSmall, theme.orbit.widthIconSmall)), _defineProperty(_tokens, TYPES.SEPARATED, css(["height:", ";width:", ";"], theme.orbit.heightIconMedium, theme.orbit.widthIconMedium)), _tokens);
  return tokens[type];
};

export var Item = styled(function (_ref) {
  var type = _ref.type,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["type", "theme"]);

  return React.createElement("li", props);
}).withConfig({
  displayName: "ListItem__Item",
  componentId: "sc-1vswvev-0"
})(["font-family:", ";display:flex;flex-direction:row;align-items:flex-start;margin-bottom:", ";&:last-child,&:last-of-type{margin:0;}", "{line-height:inherit;font-size:inherit;}", ""], function (_ref5) {
  var theme = _ref5.theme;
  return theme.orbit.fontFamily;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.orbit.spaceXXSmall;
}, StyledText, function (_ref7) {
  var type = _ref7.type,
      theme = _ref7.theme;
  return type === TYPES.SEPARATED && css(["border-bottom:1px solid ", ";padding:", ";&,", "{font-weight:", ";}:last-child{border-bottom:none;}"], theme.orbit.paletteCloudDark, theme.orbit.spaceXSmall, StyledText, theme.orbit.fontWeightMedium);
});
Item.defaultProps = {
  theme: defaultTheme
};
var IconContainer = styled.div.withConfig({
  displayName: "ListItem__IconContainer",
  componentId: "sc-1vswvev-1"
})(["display:flex;align-items:center;margin:", ";flex:0 0 auto;height:", ";", "{", ";img{", ";}}svg{", ";}"], function (_ref8) {
  var theme = _ref8.theme,
      type = _ref8.type;
  return rtlSpacing("".concat(type === TYPES.SEPARATED ? theme.orbit.spaceXXSmall : 0, " ").concat(theme.orbit.spaceXSmall, " 0 0"));
}, function (_ref9) {
  var theme = _ref9.theme,
      type = _ref9.type,
      size = _ref9.size;
  return type === TYPES.SEPARATED ? theme.heightIconLarge : getLineHeightToken({
    theme: theme,
    size: size
  });
}, StyledCarrierLogo, getIconSizeFromType, getIconSizeFromType, getIconSizeFromType);
IconContainer.defaultProps = {
  theme: defaultTheme
};
var StyledLabel = styled.div.withConfig({
  displayName: "ListItem__StyledLabel",
  componentId: "sc-1vswvev-2"
})(["font-family:", ";font-weight:", ";color:", ";font-size:", ";"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.orbit.fontFamily;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.orbit.fontWeightNormal;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.orbit.colorTextSecondary;
}, getSizeTokenLabel);
var StyledSpan = styled.span.withConfig({
  displayName: "ListItem__StyledSpan",
  componentId: "sc-1vswvev-3"
})(["width:100%;"]);
StyledLabel.defaultProps = {
  theme: defaultTheme
};

var ListItem = function ListItem(_ref13) {
  var label = _ref13.label,
      children = _ref13.children,
      _ref13$icon = _ref13.icon,
      icon = _ref13$icon === void 0 ? React.createElement(CircleSmall, null) : _ref13$icon,
      dataTest = _ref13.dataTest;

  var _useContext = useContext(ListContext),
      size = _useContext.size,
      type = _useContext.type;

  return React.createElement(Item, {
    "data-test": dataTest,
    type: type
  }, React.createElement(IconContainer, {
    type: type,
    size: size
  }, icon), React.createElement(StyledSpan, null, label && React.createElement(StyledLabel, {
    size: size
  }, label), children));
};

export default ListItem;